import { SwiperOptions } from 'swiper/types/swiper-options';

export const breakpoints: SwiperOptions['breakpoints'] = {
  320: {
    slidesPerView: 1,
    spaceBetween: 0,
  },
  768: {
    slidesPerView: 3,
    spaceBetween: 15,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 31,
  },
  1440: {
    slidesPerView: 3,
    spaceBetween: 32,
  },
};

export const breakpointsArticles: SwiperOptions['breakpoints'] = {
  320: {
    slidesPerView: 1,
    spaceBetween: 0,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 15,
  },
  1024: {
    slidesPerView: 2,
    spaceBetween: 34,
  },
  1440: {
    slidesPerView: 2,
    spaceBetween: 32,
  },
};

export default breakpoints;
